<!-- product.component.html -->
<div class="product-page">

    <!-- Header Section -->
    <section class="banner">
      <h1>Our Premium Products</h1>
      <p>Suncrest Global brings quality Indian products to the world.</p>
    </section>
  
    <!-- Product Grid -->
    <section class="product-container">
  
      <!-- Product Card -->
      <div class="product-card" *ngFor="let product of products">
  
        <div class="img-box">
          <img [src]="'assets/images/' + product.image" [alt]="product.name">
        </div>
  
        <div class="content">
          <h3>{{product.name}}</h3>
          <p>{{product.description}}</p>
          <!-- <button>View Details</button> -->
        </div>
  
      </div>
  
    </section>
  
  </div>
